module.exports = __webpack_public_path__ + "static/media/About_Infographic.e49c4c44.svg";